import {AuthSource} from 'enums';

export const EDITABLE_INTEGRATION_SOURCES = [AuthSource.AppointmentsApplication, AuthSource.Salesforce, AuthSource.SalesforceWidget];

export const PROFILE_FIELD = {
    ACCOUNT: 'accountId',
    LOGIN: 'login',
    FIRST_NAME: 'firstName',
    MIDDLE_NAME: 'middleName',
    LAST_NAME: 'lastName',
    TITLE: 'title',
    GROUPS: 'groups',
    PHONE: 'phone',
    SKYPE: 'skype',
    EMAIL: 'email',
    ROLES: 'roles',
    IN_SESSION_ROLES: 'inSessionRoles',
    OLD_PASSWORD: 'oldPassword',
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirmPassword',
};